import React from 'react'

function HightlightText({text}) {
  return (
    <span className='gradient-text'>
        {' '}
        {text}
    </span>
  )
}

export default HightlightText